import type { DateTime } from "luxon";
import type { FC } from "react";
import { MultiCommonDashboardBox } from "../../../components/Dashboard/CommonDashboardBox";
import { InHouseProgressChart } from "../../../components/UIToolkit/Graphs/ProgressChart/InHouseProgressChart";
import { useManagementCenterDownload } from "../hooks/useManagementCenterDownload";
import { useManagementCenterMultiWeekActiveUsers } from "../hooks/useManagementCenterMulti";

interface IProps {
	maxRows: number;
	width: string;
	selectedRegions: string[];
	handleItemDoubleClick: (departmentName: string) => void;
	startDate: DateTime;
	endDate: DateTime;
}

export const WeekActiveUsersChart: FC<IProps> = ({ maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate }) => {
	const { data, isLoading } = useManagementCenterMultiWeekActiveUsers({ startDate, endDate });
	const { download } = useManagementCenterDownload({ graphName: "week-active-users", startDate, endDate });
	const rawItems = data?.items || [];

	const items = (selectedRegions.length === 0 ? rawItems : rawItems.filter((item) => selectedRegions.includes(item.region))).map((item) => ({
		...item,
		title: `${item.department}, ${item.region}`,
		onDoubleClick: () => handleItemDoubleClick(item.department),
	}));

	return (
		<MultiCommonDashboardBox sx={{ display: "flex", flexDirection: "column", alignItems: "start", width }}>
			<InHouseProgressChart
				title="Weekly Active Users"
				items={items}
				threshold={{
					warning: 75,
					error: 60,
				}}
				showViewAll={true}
				maxVisibleItems={maxRows}
				statTitle="Active / Staff"
				isLoading={isLoading}
				onDownload={download}
			/>
		</MultiCommonDashboardBox>
	);
};
